<template>
  <Card :class="[`${$route.name.split('-').shift()}-mutate-customfields`]">
    <CustomFields
      v-model="value.customFields"
      :schema="customFieldSchemasComp"
      :data="data"
      :placement="customFieldsPlacement"
      :validator="validator"
      validator-prefix="customFields"
    />
  </Card>
</template>

<script>
import Card from '@/components/Card'
import CustomFields from '@kvass/custom-fields'
import { mergeDeepRight } from 'ramda'

const meta = {
  skip: true,
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    customFieldsPlacement: { type: Array, default: () => [] },
    isActive: Boolean,
  },
  computed: {
    customFieldSchemasComp() {
      return this.customFieldSchemas.map(item => {
        return mergeDeepRight(item, { options: { props: { ...item.options.props, parentIsActive: this.isActive } } })
      })
    },
  },
  components: {
    Card,
    CustomFields,
  },
}
</script>
